import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";
import verifyLogo from "@/assets/logo.png";
import ROUTES from "@/lib/routes";

export function AppFooter() {
  const isMobile = useIsMobile();
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="border-t border-glass-border bg-glass/95 backdrop-blur supports-backdrop-filter:bg-glass/60"
      role="contentinfo"
      aria-label="Site footer"
    >
      <div className={cn(
        "container mx-auto max-w-7xl",
        isMobile ? "px-4 py-4" : "px-6 py-4"
      )}>
        <div className={cn(
          "flex items-center justify-between",
          isMobile && "flex-col gap-4"
        )}>
          {/* Left: Links */}
          <nav 
            className={cn(
              "flex items-center text-sm",
              isMobile ? "order-2 gap-2" : "gap-2"
            )}
            aria-label="Footer navigation"
          >
            <span className="text-[#3366CC]">V{ROUTES.APP_VERSION}</span>
            <span className="text-gray-400" aria-hidden="true">|</span>
            <a 
              href={ROUTES.FAQ}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#3366CC] hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded"
            >
              FAQ
            </a>
            <span className="text-gray-400" aria-hidden="true">|</span>
            <a 
              href={ROUTES.PRIVACY_POLICY}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#3366CC] hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded"
            >
              Privacy Policy
            </a>
            <span className="text-gray-400" aria-hidden="true">|</span>
            <a 
              href={ROUTES.TERMS_CONDITIONS}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#3366CC] hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded"
            >
              Terms of Use
            </a>
          </nav>

          {/* Center: Powered by */}
          <div className={cn(
            "flex items-center",
            isMobile ? "order-1" : "hidden lg:flex"
          )}>
            <span className="font-bold text-sm text-[#34A5DE]">Powered</span>
            <span className="font-bold text-sm text-[#3366CC] lowercase mx-2">BY</span>
            <img 
              src={verifyLogo} 
              alt="Verif-y" 
              className="max-h-6"
            />
          </div>

          {/* Right: Copyright */}
          <p className={cn(
            "text-sm text-[#3366CC]",
            isMobile ? "order-3" : "hidden lg:block"
          )}>
            Copyright &copy; {currentYear} Verif-y, Inc.™
          </p>
        </div>
      </div>
    </footer>
  );
}
